import React, { useState } from "react";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import { getCurrencyProperties } from "../../data/currencies";
import { useDispatch, useSelector } from "react-redux";
import BalanceTopUpButton from "../../../app/common/components/BalanceTopUpButton";
import StripeCustomCheckout from "../../payments/StripeCustomCheckout";
import { closeModal } from "../../../app/common/modals/modalReducer";
import Divider from "../../../app/common/components/Divider";
import CurrencyInput from "react-currency-input-field";
import { Button } from "semantic-ui-react";
import BackButton from "../../../app/common/components/BackButton";

const TOP_UP_VIEW = 0;
const CHECKOUT_VIEW = 1;

const SELECTED_TOP_UP_BUTTON = "50.00";

export default function TopUpModal({
  amount = SELECTED_TOP_UP_BUTTON,
  amountNeeded,
  showFundsRequired = false,
}) {
  const dispatch = useDispatch();

  const { responsive } = useSelector((state) => state.app);
  const { currentUserAccount } = useSelector((state) => state.account);

  const [view, setView] = useState(TOP_UP_VIEW);
  const [inputAmount, setInputAmount] = useState(
    showFundsRequired ? amount : SELECTED_TOP_UP_BUTTON
  );
  const [paymentAmount, setPaymentAmount] = useState(
    parseFloat(showFundsRequired ? amount : SELECTED_TOP_UP_BUTTON) || 0.0
  );

  const currencySymbol = getCurrencyProperties(
    currentUserAccount.currencyCode
  ).symbol;

  function handleAmountInput(amount) {
    if (amount === undefined) {
      setInputAmount("");
      return;
    }
    setInputAmount(amount);
  }

  function handleContinueToPayment() {
    setPaymentAmount(parseFloat(inputAmount));
    setView(CHECKOUT_VIEW);
  }

  function resetTopUpPayment() {
    setView(TOP_UP_VIEW);
  }

  const isInputInvalid =
    parseFloat(inputAmount) > 200 || parseFloat(inputAmount) < 1;

  const isSelected = (value) =>
    inputAmount === value ||
    inputAmount === `${value}.0` ||
    inputAmount === `${value}.00` ||
    inputAmount === `${value}.`;

  return (
    <ModalWrapper
      modalClassName="modal-ux-wrapper"
      style={{
        width: !responsive.isMobile ? 400 : "98%",
        height: 580,
        zIndex: 2000,
      }}
      padding={30}
    >
      {view === TOP_UP_VIEW && (
        <div className="body-blue-text">
          <h3>Top up balance</h3>
          {showFundsRequired && (
            <div style={{ marginTop: 20, width: "90%" }}>
              Funds required for Standard Job Post:{" "}
              <span>
                {currencySymbol}
                {amountNeeded}
              </span>
              <Divider margin="15px 0 0" />
            </div>
          )}
          <div
            style={{ marginTop: amount !== SELECTED_TOP_UP_BUTTON ? 20 : 30 }}
          >
            Select or enter a top-up amount.
          </div>
          <div style={{ marginTop: 10 }}>
            You can add between {currencySymbol}1.00 and {currencySymbol}
            200.00
          </div>
          <div className="display-flex" style={{ marginTop: 30 }}>
            <BalanceTopUpButton
              styles={{ marginRight: 8 }}
              currencySymbol={currencySymbol}
              amount={50}
              action={() => setInputAmount("50.00")}
              isSelected={isSelected("50")}
            />
            <BalanceTopUpButton
              styles={{ marginRight: 8 }}
              currencySymbol={currencySymbol}
              amount={75}
              action={() => setInputAmount("75.00")}
              isSelected={isSelected("75")}
            />
            <BalanceTopUpButton
              styles={{ marginRight: 8 }}
              currencySymbol={currencySymbol}
              amount={100}
              action={() => setInputAmount("100.00")}
              isSelected={isSelected("100")}
            />
          </div>
          <Divider text={"or"} fontSize={11} margin={"8px 25% 8px 0"} />
          <div className="ui input">
            <CurrencyInput
              decimalSeparator={"."}
              disableGroupSeparators={true}
              allowNegativeValue={false}
              placeholder={currencySymbol}
              prefix={currencySymbol}
              value={inputAmount}
              maxLength={5}
              step={0.05}
              onValueChange={(value) => handleAmountInput(value)}
              style={{
                border:
                  inputAmount.length > 1 && isInputInvalid
                    ? "1px solid #B71B1B"
                    : "",
              }}
            />
          </div>
          <Button
            className="overwrite-button cta-orange"
            content={"Continue to payment"}
            style={{ marginTop: 24 }}
            disabled={inputAmount === "" || isInputInvalid}
            onClick={handleContinueToPayment}
          />
        </div>
      )}
      {view === CHECKOUT_VIEW && (
        <div style={{ paddingLeft: 8 }}>
          <BackButton action={resetTopUpPayment} />
          <div style={{ paddingLeft: 5 }}>
            <h2>Confirm & Pay</h2>
            <div className="body-blue-text" style={{ margin: "16px 0" }}>
              <span>Top-up amount: </span>
              <span className="semi-bold">
                {getCurrencyProperties(currentUserAccount.currencyCode).symbol}
                {paymentAmount.toFixed(2)}
              </span>
            </div>
            <StripeCustomCheckout
              amount={paymentAmount}
              resetTopUpPayment={() => dispatch(closeModal())}
              account={currentUserAccount}
            />
          </div>
        </div>
      )}
    </ModalWrapper>
  );
}
